import { render, staticRenderFns } from "./DurationInput.vue?vue&type=template&id=6cb68db6&"
import script from "./DurationInput.vue?vue&type=script&lang=js&"
export * from "./DurationInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports